import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/showToaster';
import { updateWhyHost3 } from '../../../../lib/graphql';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

async function submit(values, dispatch) {

  const isRestrict = await dispatch(demoRestriction({}));
  if (isRestrict) return;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: updateWhyHost3,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data?.updateWhyHostPage?.status === 200) {
    showToaster({ messageId: 'updateBlock4', toasterType: 'success' });
  } else {
    showToaster({ messageId: 'updateBlockError', toasterType: 'error' });
  }

}

export default submit;
